import { Pipe, PipeTransform } from '@angular/core';
import { MetricUnitsPipe } from './metric-units';
import { DistancePipe } from './distance';

@Pipe({ name: 'speedLimits' })
export class SpeedLimitsPipe implements PipeTransform {

  constructor(private metricUnitsPipe: MetricUnitsPipe, private distancePipe: DistancePipe) { }

  public transform(min: number, max: number, isMetricUnits: boolean, showUnits: boolean = true): string {
    let speedUnits: string = '';
    if (showUnits){
      speedUnits = this.metricUnitsPipe.transform(isMetricUnits, false, 'speed');
    }

    const minSpeedLimit: string = this.distancePipe.transform(min, isMetricUnits, true, '1.0-0');
    const maxSpeedLimit: string = this.distancePipe.transform(max, isMetricUnits, true, '1.0-0');

    return this.mergePostedSpeedLimits(minSpeedLimit, maxSpeedLimit, speedUnits);
  }

  private mergePostedSpeedLimits(minSpeedLimit: string, maxSpeedLimit: string, speedUnits: string): string {
    let postedSpeedLimits = `${minSpeedLimit} ${speedUnits}`;
    if (minSpeedLimit !== maxSpeedLimit) {
      postedSpeedLimits += `, ${maxSpeedLimit} ${speedUnits}`;
    }

    return postedSpeedLimits;
  }
}
